import createTemplate from "../../utils/createTemplate";

export const slideshowTemplate = createTemplate(`
<div class="listicle-slideshow listicle-slideshow__init">
    <div class="rebellt-item rebellt-item-fade-in">
        <h3></h3>
        <div class="rebellt-item-media-container">
            <div class="listicle-slideshow-media-html"></div>
            <div class="listicle-slideshow-pager">
                <a href="javascript:;" class="listicle-slideshow-switch-page-btn listicle-slideshow--prev">
                    <span>
                        <i></i>
                        <i class="fa fa-play-circle fa-flip-horizontal"></i>
                    </span>
                </a>
                <a href="javascript:;" class="listicle-slideshow-switch-page-btn listicle-slideshow--next">
                    <span>
                        <i></i>
                        <i class="fa fa-play-circle"></i>
                    </span>
                </a>
            </div>
        </div>
        <div class="image-media media-photo-credit"></div>
        <div class="image-media media-caption"></div>
        <script type="application/json"></script>
        <div class="listicle-slideshow__thumbnails clearfix"></div>
    </div>
</div>
`);

export const thumbnailTemplate = createTemplate(`
<div class="listicle-slideshow__thumbnail">
    <script type="application/json"></script>
    <div class="image crop-3x2 widget__image"></div>
</div>
`);

export const notificationTemplate = createTemplate(`
    <div class="post-update-notification" style="top: 20px; position: fixed; display: flex; width: 100%; justify-content: center;">
        <button class="update-text-content"/>
    </div>
`);

export const particleListItem = createTemplate(`
    <li>
        <a href="javascript:;">
            <span class="particle-date"></span>
            <span class="particle-title"></span>
        </a>
    </li>
`);
